import { ProductDetail } from './product-detail/ProductTypes';
import { ProductPrice } from './product-detail/ProductPriceTypes';

export type ProductsSuggestions = ProductDetail & {
  productPrice: ProductPrice;
};

export type SearchContentItem = {
  _id?: string | null;
  title: string;
  image: string;
  description: string;
  url: string;
  internalUrl: string;
  sortOrder: number;
  tags: Array<string>;
};

export type SearchContent = {
  totalElements: number;
  totalPages: number;
  size: number;
  content: Array<SearchContentItem>;
};

export type SearchSuggestions = {
  keywords: Array<SearchKeywordSuggestion>;
  brands?: Array<SearchBrandSuggestion>;
  categories?: Array<SearchCategorySuggestion>;
  brandAsCategories?: Array<SearchBrandAsCategorySuggestion>;
  products?: Array<ProductsSuggestions>;
};

export type SearchKeywordSuggestion = {
  searchTerm: string;
  itemCount: number;
};

export type SearchBrandSuggestion = {
  id: number;
  name: string;
  url: string;
  itemCount: number;
};

export type SearchCategorySuggestion = {
  id: number;
  name: string;
  url: string;
  itemCount: number;
  categoryNames: Array<string>;
};

export type SearchBrandAsCategorySuggestion = {
  brand: string;
  category: string;
  url: string;
  itemCount: number;
  categoryNames: Array<string>;
};
